/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Inject_HintInputs */

const en_keyword_optimizer_inject_hint = /** @type {(inputs: Keyword_Optimizer_Inject_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uses 1 credit`)
};

const de_keyword_optimizer_inject_hint = /** @type {(inputs: Keyword_Optimizer_Inject_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbraucht 1 Credit`)
};

const fr_keyword_optimizer_inject_hint = /** @type {(inputs: Keyword_Optimizer_Inject_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilise 1 crédit`)
};

const es_keyword_optimizer_inject_hint = /** @type {(inputs: Keyword_Optimizer_Inject_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consume 1 crédito`)
};

const it_keyword_optimizer_inject_hint = /** @type {(inputs: Keyword_Optimizer_Inject_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa 1 credito`)
};

const nl_keyword_optimizer_inject_hint = /** @type {(inputs: Keyword_Optimizer_Inject_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kost 1 credit`)
};

const pl_keyword_optimizer_inject_hint = /** @type {(inputs: Keyword_Optimizer_Inject_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zużywa 1 kredyt`)
};

const fi_keyword_optimizer_inject_hint = /** @type {(inputs: Keyword_Optimizer_Inject_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käyttää 1 krediitin`)
};

const da_keyword_optimizer_inject_hint = /** @type {(inputs: Keyword_Optimizer_Inject_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bruger 1 credit`)
};

const sv_keyword_optimizer_inject_hint = /** @type {(inputs: Keyword_Optimizer_Inject_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Använder 1 credit`)
};

/**
* | output |
* | --- |
* | "Uses 1 credit" |
*
* @param {Keyword_Optimizer_Inject_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_inject_hint = /** @type {((inputs?: Keyword_Optimizer_Inject_HintInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Inject_HintInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_inject_hint(inputs)
	if (locale === "fr") return fr_keyword_optimizer_inject_hint(inputs)
	if (locale === "es") return es_keyword_optimizer_inject_hint(inputs)
	if (locale === "it") return it_keyword_optimizer_inject_hint(inputs)
	if (locale === "nl") return nl_keyword_optimizer_inject_hint(inputs)
	if (locale === "pl") return pl_keyword_optimizer_inject_hint(inputs)
	if (locale === "fi") return fi_keyword_optimizer_inject_hint(inputs)
	if (locale === "da") return da_keyword_optimizer_inject_hint(inputs)
	if (locale === "sv") return sv_keyword_optimizer_inject_hint(inputs)
	return en_keyword_optimizer_inject_hint(inputs)
});